import { render } from "./ListeCategorieOffrePage.vue?vue&type=template&id=38418e0a&ts=true"
import script from "./ListeCategorieOffrePage.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieOffrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__